import PageLayout from '@hellodarwin/app-core/lib/layouts/page-layout';
import Container from '@hellodarwin/core/lib/components/common/container';
import BusinessProfile from '@hellodarwin/core/lib/components/company/business-profile';
import useLocale from '@hellodarwin/core/lib/features/providers/locale-provider';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../app/app-hooks';
import GamePlanFilesList from '../../components/projects/game-plan-files';
import ProjectsTable from '../../components/projects/projects-table';
import {
  fetchCompany,
  selectCompany,
} from '../../features/api/slices/profile-slice';
import {
  fetchGamePlans,
  selectAllGamePlans,
} from '../../features/api/slices/projects-slice';
import {
  fetchIndustries,
  selectIndustriesSectors,
  selectIndustriesSubsectors,
} from '../../features/api/slices/tags-slice';
import {
  useClientApi,
  useNewClientApi,
} from '../../features/api/use-client-api';

const ClientProjectsPage = () => {
  const { t } = useTranslation();
  const { t: hdT } = useTranslations();
  const company = useAppSelector(selectCompany);

  const api = useClientApi();
  const newApi = useNewClientApi();
  const dispatch = useAppDispatch();
  const { selectedLocale } = useLocale();

  const industries = useAppSelector(selectIndustriesSectors);
  const subindustries = useAppSelector(selectIndustriesSubsectors);
  const gamePlans = useAppSelector(selectAllGamePlans);

  useEffect(() => {
    dispatch(fetchIndustries({ api, locale: selectedLocale }));
    dispatch(fetchCompany({ api }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLocale]);

  useEffect(() => {
    if (company.company_id) {
      dispatch(fetchGamePlans({ api: newApi }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company.company_id]);

  return (
    <PageLayout
      app="client"
      title={hdT('navigation|planning')}
      breadcrumbs={[
        {
          breadcrumbName: t('navigation.home'),
          path: '/',
        },
        {
          breadcrumbName: hdT('navigation|planning'),
        },
      ]}
    >
      <Container
        header={{
          label: t('project|businessProfile'),
        }}
      >
        <BusinessProfile
          company={company}
          industries={industries}
          subindustries={subindustries}
        />
      </Container>
      <Container
        header={{
          label: t('project|yourProjects'),
        }}
      >
        <ProjectsTable />
      </Container>
      <Container
        header={{
          label: hdT('game-plan-cycles|title'),
        }}
        styles={{ content: { padding: 0 } }}
      >
        <GamePlanFilesList gamePlans={gamePlans} />
      </Container>
    </PageLayout>
  );
};

export default ClientProjectsPage;
